import React from 'react';
import 'CSS/demand-supply/demand-supply.scss';
import 'CSS/dashboard-statistic.scss';
import 'CSS/dashboard-tickets.scss';
import 'CSS/dashboard-slips.scss';
import Grid from '@material-ui/core/Grid';
import { API_ROOT } from '../../../../../../../api/Routes';

import styled from 'styled-components';

const SupImg = styled.div`
  text-align: -webkit-center;
`;

const SupplyPhoto = ({ photos }) => {
  if (photos.length === 0) return null;
  return (
    <Grid container spacing={16} className={'pBot-10 '}>
      <Grid item xs={12} className="">
        <h2 className="t-primary-16 t-weight-b u-mrg-bot-0 u-mrg-top-10">
          Supply photo
        </h2>
      </Grid>
      <Grid
        container
        spacing={16}
        className="demand-slip__photos pBot-10 u-pad-l-10 "
      >
        {/* <Grid item xs={12} md={6}> */}
        {photos.map((asset, i) => (
          <Grid item key={i} xs={12} md={6}>
            <SupImg>
              <img
                style={{
                  cursor: 'pointer',
                }}
                key={i}
                alt="Supply"
                className="demand-slip__photo"
                src={`${API_ROOT}/asset/${asset}`}
                onClick={() => {
                  var link = document.createElement('a');
                  link.href = `${API_ROOT}/asset/${asset}`;
                  // link.download = 'Download.jpg';
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
                }}
              />
            </SupImg>
          </Grid>
        ))}
        {/* </Grid> */}
      </Grid>
    </Grid>
  );
};

SupplyPhoto.defaultProps = {
  photos: [],
};

export default SupplyPhoto;
